<template>
	<section class="app-container form-high-contrast wide-section">
		<div class="container add-photos-container">
			<h1>Add Photos for Recent Checklists</h1>
			<div v-if="current_user">
				<div class="row">
					<div class="col-sm-3">
						<div class="spinner-wrapper" v-show="checklists_loading">
							<span class="spinner-text">LOADING</span>
							<span class="spinner"></span>
						</div>
						<h5>Select a checklist to add photos.</h5>
						<ul class="oc-side-nav">
							<li v-for="checklist in checklists" v-if="checklist.datetime" v-bind:class="{ active: is_active(checklist) }">
								<a @click="loadList(checklist)" href="javascript:void(0);">
									<strong class="notranslate" translate="no">{{checklist.location_data.display_name}}</strong><br />
									{{ checklist.datetime.split('T')[0] | moment(momentDisplayFormat()) }}
								</a>
							</li>
						</ul>
						<Paging></Paging>
					</div>
					<div class="col-sm-9">
						<div class="spinner-wrapper" v-show="records_loading">
							<span class="spinner-text">LOADING</span>
							<span class="spinner"></span>
						</div>
						<h3 v-if="current_list">
							Photos for {{ current_list.datetime.split('T')[0] | moment(momentDisplayFormat()) }} @ <strong class="notranslate" translate="no">{{current_list.location_data.display_name}}</strong>
						</h3>
						<div class="row row-pull-out">
							<div class="col-md-6">
								<button class="btn btn--primary btn-sm type--uppercase btn-block" v-if="current_sightings && current_sightings.length" @click="save()">Save All</button>
							</div>
							<div class="col-md-6">
								<button class="btn btn-sm type--uppercase btn-block" v-if="current_sightings && current_sightings.length" @click="save(true)">Save All &amp; Exit</button>
							</div>
						</div>
						<div v-if="!records_loading && current_sightings" class="row-sighting-photo-add">
							<div v-for="sighting in current_sightings">
								<div class="boxed boxed--border sighting-container">
									<div class="sighting-info">
										<h5>
											{{sighting.taxon_data.common_name}}<br /><em>({{sighting.taxon_data.scientific_name}})</em>
										</h5>
										<h6>{{sighting.count}} | {{sighting.life_stage_data.name}}</h6>
									</div>
									<ImageManagerHorizontal v-if="sighting.can_edit" v-model="sighting.photos" :uniqueid="'file-upload-extra' +sighting.id"></ImageManagerHorizontal>
									<div class="uneditable" v-if="!sighting.can_edit">
										<h4><strong>Vetted Record</strong> This record can only be edited with vetter permission.</h4>
									</div>
								</div>
							</div>
						</div>
						<div class="row row-pull-out">
							<div class="col-md-6">
								<button class="btn btn--primary btn-sm type--uppercase btn-block" v-if="current_sightings && current_sightings.length" @click="save()">Save All</button>
							</div>
							<div class="col-md-6">
								<button class="btn btn-sm type--uppercase btn-block" v-if="current_sightings && current_sightings.length" @click="save(true)">Save All &amp; Exit</button>
							</div>
						</div>
						<div v-if="!current_sightings || !current_sightings.length">
							<strong>No Sightings</strong>
						</div>
					</div>
				</div>
			</div>
			<div v-else>
				<div class="alert">
					<div class="alert__body">
						<span>Please login to add photos to sightings.</span>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import axios from 'axios';
	import global_data from '../../main';
	export default {
		name: 'AccountPhotosComponent',
		metaInfo: {
			title: 'Add Checklist Photos',
		},
		data: function(){
			return {
				loading_user: true,
				checklists_loading:false,
				records_loading: false,
				current_user: null,
				checklists: null,
				current_list: null,
				current_sightings: null,
				meta: {
					page: 0,
					per_page: 0,
					total_pages: 0,
					total_results: 0,
				},
				page: 1
			};
		},
		mounted: function(){
			var self = this;
			global_data.$on("user_changed", function(user){
				self.get_user_and_checklists();
			});
		},
		watch:{
		},
		methods:{
			save(exit){
				var self = this;
				var errors = false;
				var all_saves = [];
				for (var i = this.current_sightings.length - 1; i >= 0; i--) {
					if (this.current_sightings[i].can_edit) {
						all_saves.push(
							this.save_sighting(
								this.current_sightings[i],
								function(){
								},
								function(){
									errors = true;
								}
							)
						);
					}
				}
				Promise.all(all_saves).then(function(){
					if (errors) {
						self.$notify({
							text: 'There was an error saving your photos.',
							type: 'error',
						});
					}
					else{
						self.$notify({
							text: 'Photos Saved',
							type: 'success',
						});
						if (exit) {
							window.location = "/";
						}
					}
				})
			},
			save_sighting(sighting, on_success, on_error){
				var photos = [];
				if (sighting.photos) {
					for (var i = 0; i < sighting.photos.length; i++) {
						if (sighting.photos[i].response.sighting_photo) {
							photos.push(sighting.photos[i].response.sighting_photo.id);
						}
					}
				}

				var patch_data = {
					"photos": photos,
				}

				var self = this;
				return this.API({
					endpoint: 'sightings/' + sighting.id,
					isPatch:true,
					postData: patch_data,
					funcThen: on_success,
					funcCatch: on_error,
				});
			},
			is_active(checklist){
				return this.current_list && checklist.id == this.current_list.id;
			},
			get_user_and_checklists: function(){
				var self = this;
				self.GetAPIUser(function(user){
					self.current_user = user;
					self.loading_user = false;

					if (self.current_user) {
						self.get_user_checklists();
					}
				}, true);
			},
			get_user_checklists:function(){
				var self = this;
				if (!self.current_user) {
					self.checklists = null;
					return;
				}

				self.checklists_loading = true;

				var qs = "&filter{user.id}=" + self.current_user.id;
				qs += "&include[]=location.*";
				qs+="&sort[]=-id";
				qs+="&per_page=10";
				qs+="&page=" + self.page;
				this.API({
					endpoint: 'checklists',
					querystring: qs,
					funcThen: function(response){
						self.checklists = self.combineSightingData(response.data);
						self.meta = response.data.meta;
						if (self.checklists.length > 0 && !self.current_sightings) {
							self.loadList(self.checklists[0])
						}
					},
					funcAfterThen: function(){
						self.checklists_loading = false;
					}
				});
			},
			combineSightingData: function(data){
				for (var i = 0; i < data.checklists.length; i++) {
					data.checklists[i].location_data = data.locations.find(u => u.id == data.checklists[i].location);
				}
				return data.checklists;
			},
			remove_uneditable: function(sightings){
				var i = sightings.length;
				while (i--){
					if (!sightings[i].can_edit) {
						sightings.splice(i,1);
					}
				}
				return sightings;
			},
			loadList: function(checklist){
				this.current_list = checklist;

				var self = this;
				var qs = "";
				qs += "&include[]=checklist.user.*";
				qs += "&include[]=checklist.location.*";
				qs += "&include[]=checklist.location.parent.*";
				qs += "&include[]=status.*";
				qs += "&include[]=checklist.*";
				qs += "&include[]=taxon.*";
				qs += "&include[]=life_stage.*";
				qs += "&include_declined=true";
				qs += "&filter{checklist.id}=" + checklist.id;
				qs += '&per_page=1000';
				qs +="&sort[]=taxon.suborder.scientific_name";
				qs +="&sort[]=taxon.family.scientific_name";
				qs +="&sort[]=taxon.scientific_name";

				self.records_loading = true;

				this.API({
					endpoint: 'sightings',
					querystring: qs,
					funcThen: function(response){
						// response.data.sightings = self.remove_uneditable(response.data.sightings);
						var working_sightings = self.CombineSightingData(response.data);
						for (var i = working_sightings.length - 1; i >= 0; i--) {
							for (var j = working_sightings[i].photos.length - 1; j >= 0; j--) {
								working_sightings[i].photos[j] = self.api_photo_to_vue(working_sightings[i].photos[j]);
							}
						}
						self.current_sightings = working_sightings;
					},
					funcAfterThen: function(){
						self.records_loading = false;
					}
				});
			},
			api_photo_to_vue: function(api_photo){
				return {
						"id": api_photo.id,
						"fileObject": true,
						"active": false,
						"success": true,
						"response": {
							"sighting_photo": api_photo
						},
						"progress": "100.00",
						"thumb": api_photo.small,
				};
			},
		},
		computed:{
			loading:{
				get: function(){
					return this.loading_user || this.checklists_loading;
				}
			},
			max_page: function(){
				return this.meta.total_pages;
			},
		},
		watch:{
			page: function(){
				this.get_user_checklists();
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/pages/AccountPhotos.vue